import axios from "axios";
import Cookies from "js-cookie";
import { API_URL, API_SECRET } from "./Api";

if (
  process.env.NODE_ENV === "development" &&
  !process.env.REACT_APP_API_SECRET?.trim()
) {
  // eslint-disable-next-line no-console
  console.info(
    "[admin] Using default API_SECRET; set REACT_APP_API_SECRET in .env.local to match api SECRET_KEY."
  );
}

axios.defaults.withCredentials = true;

const ApiPath = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer ${API_SECRET}`,
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

ApiPath.interceptors.response.use(
  (response) => response,
  (error) => {
    // eslint-disable-next-line no-console
    console.error("ApiPath error:", error.response?.status, error.message);
    if (error.response?.status === 403) {
      Cookies.removeItem("Id");
    }
    return Promise.reject(error);
  }
);

export default ApiPath;
